import PropTypes from "prop-types"
import { useState } from "react"

// Next Router
import Link from "next/link"
import { useRouter } from "next/router"

// MUI
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { alpha, styled, useTheme } from "@mui/material/styles"

// ----------------------------------------------------------------------

const ListItemStyle = styled(props => <ListItemButton disableRipple disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body1,
  height: 50,
  position: "relative",
  textTransform: "capitalize",
  color: theme.palette.mode === "dark" ? "#fff" : "#000000",
  borderRadius: "0px"
}))

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func
}

function NavItem({ item, active }) {
  const theme = useTheme()

  const isActiveRoot = active(item.path)

  const { title, path, icon: Icon, info, children } = item

  const [open, setOpen] = useState(isActiveRoot)

  const handleOpen = () => {
    setOpen(prev => !prev)
  }

  const activeRootStyle = {
    color: theme.palette.mode === "dark" ? "#fff" : "primary.main",
    borderRight: `2px solid ${theme.palette.primary.main}`,
    fontWeight: "fontWeightMedium",
    bgcolor:
      theme.palette.mode === "dark" ? alpha(theme.palette.grey[50], 0.06) : alpha(theme.palette.primary.light, 0.09)
  }

  const activeSubStyle = {
    color: "text.primary",
    fontWeight: "fontWeightMedium"
  }

  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle)
          }}
        >
          <ListItemIconStyle>
            <Icon />
          </ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info}
        </ListItemStyle>

        <Collapse in={open} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            {children.map(item => {
              const { title, path } = item
              const isActiveSub = active(path)

              return (
                <ListItemStyle
                  key={title}
                  component={Link}
                  href={path}
                  sx={{
                    ...(isActiveSub && activeSubStyle)
                  }}
                >
                  <ListItemIconStyle>
                    <Box
                      component='span'
                      sx={{
                        width: 4,
                        height: 4,
                        display: "flex",
                        borderRadius: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "text.disabled",
                        transition: theme => theme.transitions.create("transform"),
                        ...(isActiveSub && {
                          transform: "scale(2)",
                          bgcolor: "primary.main"
                        })
                      }}
                    />
                  </ListItemIconStyle>
                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              )
            })}
          </List>
        </Collapse>
      </>
    )
  }

  return (
    <ListItemStyle
      component={Link}
      href={path}
      sx={{
        ...(isActiveRoot && activeRootStyle)
      }}
    >
      <ListItemIconStyle>
        <Icon />
      </ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  )
}

Index.propTypes = {
  navConfig: PropTypes.array
}

export default function Index({ navConfig, ...other }) {
  const router = useRouter()
  const { pathname } = router

  const match = path => {
    if (path) {
      return pathname === path || pathname.includes(path)
    } else return false
  }

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 0 }}>
        {navConfig.map(item => (
          <NavItem key={item.title} item={item} active={match} />
        ))}
      </List>
    </Box>
  )
}
